export default {
  TrackingVersion: 'dimension1',
  ClientId: 'dimension2',
  WindowId: 'dimension3',
  HitId: 'dimension4',
  HitTime: 'dimension5',
  HitType: 'dimension6',
  HitSource: 'dimension7',
  VisibilityState: 'dimension8'
}



// WEBPACK FOOTER //
// ./plugins/my-analytics-plugin/src/dimensions.js